import React from "react";

import { Checkbox, CheckboxProps } from "@chakra-ui/react";

import { useFormContext } from "react-hook-form";

import { generateTestId } from "@/util/testIds";

export interface FormCheckboxProps extends CheckboxProps {
  name: string;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  ...props
}) => {
  const { register } = useFormContext();

  return (
    <Checkbox
      {...register(name, { disabled: props.isDisabled })}
      data-testid={generateTestId.form("checkbox", name)}
      {...props}
    />
  );
};
